import { CallTimeEnum, GetUserSessionIdReturnCodeEnum, RegStatus, VerificationTypeEnum, VerifyConfirmationCodeReturnCodeEnum } from "./enums";
import { ConfirmationChannel } from "./confirmationChannel";

export class UserSession {

    constructor({ sugTaagid = 0, misparTaagid = "", disclaimer = false, declaration = false, id = "", userSessionId = "" }
        : { sugTaagid?: number, misparTaagid?: string, disclaimer?: boolean, declaration?: boolean, id?: string, userSessionId?: string }) {
        this._sugTaagid = sugTaagid;
        this._misparTaagid = misparTaagid;
        this._disclaimer = disclaimer;
        this._declaration = declaration;
        this._id = id;
        this._userSessionId = userSessionId;
    }

    private _sugTaagid: number;
    private _misparTaagid: string;
    private _disclaimer: boolean;
    private _declaration: boolean;
    private _id: string;
    private _userSessionId: string;
    private _getUserSessionIdReturnCode: GetUserSessionIdReturnCodeEnum | null = null;
    private _idConfirmChannels: ConfirmationChannel[] = [];
    private _confirmChannel: ConfirmationChannel | null = null;
    private _verificationType: VerificationTypeEnum | null = null;
    private _verifyConfirmationCodeReturnCode: VerifyConfirmationCodeReturnCodeEnum | null = null;
    private _firstName: string | null = null;
    private _lastName: string | null = null;
    private _email: string | null = null;
    private _phoneNumber: string | null = null;

    private _confirmedPhone: string | null = null;
    private _confirmedEmail: string | null = null;
    private _verificationCodeRedirectUrl: string | null = null;
    private _dbCoreToken: string | null = null;
    private _callTime: CallTimeEnum | null = null;

    private _tmpPhone: string | null = null;
    private _tmpEmail: string | null = null;
    private _isRep: boolean = false;

    private _regStatus: RegStatus | null = null;

    private _contactRoleDesc: string | null = null;

    private _googleHashTag: string | null = null;

    private _tkn: string | null = null;


    private save() {
        sessionStorage.setItem("userSession", JSON.stringify(this));
    }

    get Tkn(): string | null {

        return this._tkn;
    }

    set Tkn(value: string | null) {
        this._tkn = value;
        this.save();
    }

    get GoogleHashTag(): string | null {

        return this._googleHashTag;
    }

    set GoogleHashTag(value: string | null) {

        this._googleHashTag = value;
        this.save();
    }

    get ContactRoleDesc(): string | null {

        return this._contactRoleDesc;
    }

    set ContactRoleDesc(value: string | null) {
        this._contactRoleDesc = value;
        this.save();
    }

    get RegStatus(): RegStatus | null {

        return this._regStatus;
    }

    set RegStatus(value: RegStatus | null) {

        this._regStatus = value;
        this.save();
    }

    get IsRep(): boolean {

        return this._isRep;
    }

    set IsRep(value: boolean) {
        this._isRep = value;
        this.save();
    }

    get TmpPhone(): string | null {

        return this._tmpPhone;
    }

    set TmpPhone(value: string | null) {
        this._tmpPhone = value;
        this.save();
    }

    get TmpEmail(): string | null {

        return this._tmpEmail;
    }

    set TmpEmail(value: string | null) {
        this._tmpEmail = value;
        this.save();
    }

    get CallTime(): CallTimeEnum | null {

        return this._callTime;
    }

    set CallTime(value: CallTimeEnum | null) {
        this._callTime = value;
        this.save();
    }

    get DbCoreToken(): string | null {

        return this._dbCoreToken;
    }

    set DbCoreToken(value: string | null) {

        this._dbCoreToken = value;
        this.save();
    }

    get VerificationCodeRedirectUrl(): string | null {

        return this._verificationCodeRedirectUrl;
    }

    set VerificationCodeRedirectUrl(value: string | null) {

        this._verificationCodeRedirectUrl = value;
        this.save();
    }

    get ConfirmedEmail(): string | null {

        return this._confirmedEmail;
    }

    set ConfirmedEmail(value: string | null) {

        this._confirmedEmail = value;
        this.save();
    }

    get ConfirmedPhone(): string | null {

        return this._confirmedPhone;
    }

    set ConfirmedPhone(value: string | null) {

        this._confirmedPhone = value;
        this.save();
    }

    get PhoneNumber(): string | null {

        return this._phoneNumber;
    }

    set PhoneNumber(value: string | null) {

        this._phoneNumber = value;
        this.save();
    }

    get Email(): string | null {

        return this._email;
    }

    set Email(value: string | null) {

        this._email = value;
        this.save();
    }

    get LastName(): string | null {

        return this._lastName;
    }

    set LastName(value: string | null) {

        this._lastName = value;
        this.save();
    }

    get FirstName(): string | null {

        return this._firstName;
    }

    set FirstName(value: string | null) {

        this._firstName = value;
        this.save();
    }


    get VerifyConfirmationCodeReturnCode(): VerifyConfirmationCodeReturnCodeEnum | null {

        return this._verifyConfirmationCodeReturnCode;
    }

    set VerifyConfirmationCodeReturnCode(value: VerifyConfirmationCodeReturnCodeEnum | null) {

        this._verifyConfirmationCodeReturnCode = value;
        this.save();
    }

    get VerificationType(): VerificationTypeEnum | null {
        return this._verificationType;
    }

    set VerificationType(value: VerificationTypeEnum | null) {
        this._verificationType = value;
        this.save();
    }

    get UserSessionId(): string {
        return this._userSessionId;
    }

    set UserSessionId(value: string) {
        this._userSessionId = value;
        this.save();
    }

    get ConfirmChannel(): ConfirmationChannel | null {
        return this._confirmChannel;
    }

    set ConfirmChannel(value: ConfirmationChannel | null) {
        this._confirmChannel = value;
        this.save();
    }

    get Id(): string {
        return this._id;
    }

    set Id(value: string) {
        this._id = value;
        this.save();
    }

    get MisparTaagid(): string {
        return this._misparTaagid;
    }

    set MisparTaagid(value: string) {
        this._misparTaagid = value;
        this.save();
    }

    get SugTaagid(): number {
        return this._sugTaagid;
    }

    set SugTaagid(value: number) {
        this._sugTaagid = value;
        this.save();
    }

    get Disclaimer(): boolean {
        return this._disclaimer;
    }

    set Disclaimer(value: boolean) {
        this._disclaimer = value;
        this.save();
    }

    get Declaration(): boolean {
        return this._declaration;
    }

    set Declaration(value: boolean) {
        this._declaration = value;
        this.save();
    }

    get GetUserSessionIdReturnCode(): GetUserSessionIdReturnCodeEnum | null {
        return this._getUserSessionIdReturnCode;
    }

    set GetUserSessionIdReturnCode(value: GetUserSessionIdReturnCodeEnum) {
        this._getUserSessionIdReturnCode = value;
        this.save();
    }

    get IdConfirmChannels(): ConfirmationChannel[] {
        return this._idConfirmChannels;
    }

    set IdConfirmChannels(value: ConfirmationChannel[]) {
        this._idConfirmChannels = value;
        this.save();
    }
}